module.exports = __webpack_public_path__ + "img/scroll-down.77634209.svg";